import { Row } from "antd";
import { Conversation } from "./Conversation";
import AddressInfo from "./AddressInfo";
import { ISelectedConversation } from "../../../../types/SelectedConversation";

type ConversationsProps = {
  data: any[];
  propertyAddress: string | null;
  contractNumber: number;
  conversation: ISelectedConversation | null;
  readConversation: (
    contractNumber: number,
    selectedConvValues: ISelectedConversation
  ) => void;
};

export const Conversations = ({
  data,
  conversation,
  propertyAddress,
  contractNumber,
  readConversation,
}: ConversationsProps) => {
  return (
    <Row className="d-block w-100 mb-6">
      {data.length > 0 && (
        <AddressInfo
          propertyAddress={propertyAddress}
          contractNumber={contractNumber}
        />
      )}
      {data.map((item: any) => (
        <Conversation
          key={item.id}
          item={item}
          contractNumber={contractNumber}
          conversation={conversation}
          readConversation={readConversation}
        />
      ))}
    </Row>
  );
};
